import { IconBulb, IconFileText, IconSearch } from "@tabler/icons-react";
import type React from "react";

export function toolIcon(toolName: string | null, size = 32): React.ReactNode {
    switch (toolName) {
        case "readDocument":
            return <IconFileText size={size} />;
        case "documentSearch":
            return <IconSearch size={size} />;
        case "brainstorm":
            return <IconBulb size={size} />;
        default:
            return null;
    }
}
